// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.landing-page {
  display: flex;
  justify-content: center;
  overflow: hidden;
  position: fixed;
}

.landing-page .nav {
  top: unset;
  bottom: 0px;
}

.landing-page__main-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  width: 100%;
}

.landing-page__page-video {
  border: 25px solid black;
  box-sizing: border-box;
  object-fit: cover;
  object-position: left;
  height: 100vh;
  width: 100vw;
}

.landing-page__img {
}

.landing-page__loader-img {
  height: 100vh;
  width: 100vw;
}

#root > div > main > div > div > a > h1 {
  font-family: system-ui;
  font-weight: 500;
}

.landing-page-about-me {
  position: fixed;
  top: 30px;
  right: 30px;

  height: 50px;
  width: 100px;

  background: #00000099;
  color: white;

  border: 3px solid white;
  border-radius: 5%;
}

.landing-page-a {
  align-self: center;
  animation: pulse 2s infinite;
  position: fixed;
  top: 515px;

  width: 100px;
  height: 50px;
  font-family: system-ui;

  background-color: rgba(255, 255, 255, 0);
  color: white;

  border: 3px solid white;
  border-radius: 5%;
}

.landing-page-profile-card {
  display: flex;
  justify-content: center;
  position: fixed;
  align-self: center;
  top: 95px;
}

@keyframes pulse {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.7);
  }

  70% {
    transform: scale(1);
    box-shadow: 0 0 0 10px rgba(255, 255, 255, 0);
  }

  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(255, 255, 255, 0);
  }
}

@media (max-width: 696px) {
  .landing-page-a {
    /* top: 70%; */
  }
}

/* @media (max-width: 425px) {
	.profile-card {
		left: 20%;
	}

	.landing-page-h1 {
		left: 23%;
		bottom: 75%;
	}

	.landing-page-a {
		left: 38%;
	}
} */
`, "",{"version":3,"sources":["webpack://./src/components/pages/landing-page/landing-page.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,sBAAsB;EACtB,iBAAiB;EACjB,qBAAqB;EACrB,aAAa;EACb,YAAY;AACd;;AAEA;AACA;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,WAAW;;EAEX,YAAY;EACZ,YAAY;;EAEZ,qBAAqB;EACrB,YAAY;;EAEZ,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;EACf,UAAU;;EAEV,YAAY;EACZ,YAAY;EACZ,sBAAsB;;EAEtB,wCAAwC;EACxC,YAAY;;EAEZ,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE;IACE,sBAAsB;IACtB,4CAA4C;EAC9C;;EAEA;IACE,mBAAmB;IACnB,6CAA6C;EAC/C;;EAEA;IACE,sBAAsB;IACtB,0CAA0C;EAC5C;AACF;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;;;;;;;;;;;;;GAaG","sourcesContent":[".landing-page {\n  display: flex;\n  justify-content: center;\n  overflow: hidden;\n  position: fixed;\n}\n\n.landing-page .nav {\n  top: unset;\n  bottom: 0px;\n}\n\n.landing-page__main-wrapper {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  text-align: center;\n  width: 100%;\n}\n\n.landing-page__page-video {\n  border: 25px solid black;\n  box-sizing: border-box;\n  object-fit: cover;\n  object-position: left;\n  height: 100vh;\n  width: 100vw;\n}\n\n.landing-page__img {\n}\n\n.landing-page__loader-img {\n  height: 100vh;\n  width: 100vw;\n}\n\n#root > div > main > div > div > a > h1 {\n  font-family: system-ui;\n  font-weight: 500;\n}\n\n.landing-page-about-me {\n  position: fixed;\n  top: 30px;\n  right: 30px;\n\n  height: 50px;\n  width: 100px;\n\n  background: #00000099;\n  color: white;\n\n  border: 3px solid white;\n  border-radius: 5%;\n}\n\n.landing-page-a {\n  align-self: center;\n  animation: pulse 2s infinite;\n  position: fixed;\n  top: 515px;\n\n  width: 100px;\n  height: 50px;\n  font-family: system-ui;\n\n  background-color: rgba(255, 255, 255, 0);\n  color: white;\n\n  border: 3px solid white;\n  border-radius: 5%;\n}\n\n.landing-page-profile-card {\n  display: flex;\n  justify-content: center;\n  position: fixed;\n  align-self: center;\n  top: 95px;\n}\n\n@keyframes pulse {\n  0% {\n    transform: scale(0.95);\n    box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.7);\n  }\n\n  70% {\n    transform: scale(1);\n    box-shadow: 0 0 0 10px rgba(255, 255, 255, 0);\n  }\n\n  100% {\n    transform: scale(0.95);\n    box-shadow: 0 0 0 0 rgba(255, 255, 255, 0);\n  }\n}\n\n@media (max-width: 696px) {\n  .landing-page-a {\n    /* top: 70%; */\n  }\n}\n\n/* @media (max-width: 425px) {\n\t.profile-card {\n\t\tleft: 20%;\n\t}\n\n\t.landing-page-h1 {\n\t\tleft: 23%;\n\t\tbottom: 75%;\n\t}\n\n\t.landing-page-a {\n\t\tleft: 38%;\n\t}\n} */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
